
export default {
  userKey : '__xr_userinfo',
  addUser : function(us){
    this.delUser()

    //window.localStorage.setItem(this.userKey, us)
    
    var date=new Date(); //获取当前时间
    date.setTime(date.getTime()+ 1*24*3600*1000); //格式化为cookie识别的时间
    document.cookie= this.userKey + "=" + us +";expires="+date.toGMTString();  //设置cookie
  },
  updateUser : function(us){
    this.addUser(us)
  },
  getUser : function(){
    var getCookie = document.cookie.replace(/[ ]/g,"");  //获取cookie，并且将获得的cookie格式化，去掉空格字符
    var arrCookie = getCookie.split(";")  //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
    var tips;  //声明变量tips
    for(var i=0;i<arrCookie.length;i++){   //使用for循环查找cookie中的tips变量
      var arr=arrCookie[i].split("=");   //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
      if(this.userKey==arr[0]){  //匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
        tips=arr[1];   //将cookie的值赋给变量tips
        break;   //终止for循环遍历
      }
    }
    if(tips == undefined || tips == 'undefined'){
      tips = ''
    }
    return tips;//window.localStorage.getItem(this.userKey)
  },
  delUser : function(){
    var date = new Date(); //获取当前时间
    date.setTime(date.getTime()-10000); //将date设置为过去的时间
    document.cookie = this.userKey + "=v; expires =" +date.toGMTString();//设置cookie
    return //window.localStorage.removeItem(this.userKey)
  }
}



// WEBPACK FOOTER //
// ./src/util/cache.js